import { createFileRoute } from "@tanstack/solid-router"

export const Route = createFileRoute("/_authenticated/tablet/$orgId/_tablet/settings/")({
  component: RouteComponent
})

function RouteComponent() {
  return <div>Hello "/tablet/$orgId/_dash/settings/"!</div>
}
